import FilterSidebar from '@/client/components/FilterSidebar/organisms/FilterSidebar';

export default FilterSidebar;
